import { useEffect, useRef } from "react";
import { useI18n } from "../i18n.jsx";

// React and legacy tools share one accessible inquiry dialog and form.
export default function PlusUpgradeModal({ open, onClose, source = "plus-modal" }) {
  const { locale } = useI18n();
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const dialog = window.SielpaPlusEnquiry.open({
      locale, source, onClose: () => closeRef.current()
    });
    return () => dialog.close(false);
  }, [open, locale, source]);

  return null;
}
